import Vue from "vue"
import plannedTx from "@/utils/plannedTx"

const state = {
  planned: [],
  pending: []
}

export const mutations = {
  ADD_PENDING_TX(state, tx) {
    state.pending.push(tx)
  },

  ADD_PLANNED_TX(state, tx) {
    state.planned.push(tx)
  },

  CLEAR_PLANNED_TX(state) {
    for (let { tx } of state.planned) {
      tx.cancel()
    }

    state.planned = []
  },

  DEQUEUE_PLANNED_TX(state) {
    state.planned.shift()
  },

  REMOVE_PENDING_TX(state, hash) {
    const id = state.pending.findIndex(tx => tx.hash === hash)
    if (id === -1) return

    state.pending.splice(id, 1)
  }
}

export const actions = {
  async addPlannedTx({ rootState, commit }, options) {
    commit("CLEAR_PLANNED_TX")

    const { allowance } = options
    if (allowance) {
      const Platform = await rootState.contracts.Platform
      const Token = await rootState.contracts.Token

      const userAllowance = await Token.allowance(rootState.web3.account, Platform.address)

      if (userAllowance < allowance) {
        if (userAllowance !== 0) {
          commit("ADD_PLANNED_TX", {
            tx: plannedTx(() => Token.approve(Platform.address, 0)),
            header: "Reset allowance",
            body: `Your current allowance is insufficient for this transaction. You must reset your allowance to continue.`
          })
        }

        commit("ADD_PLANNED_TX", {
          tx: plannedTx(() => Token.approve(Platform.address, allowance)),
          header: "Approve MTX transfer",
          body: `This transaction requires an allowance of ${allowance} MTX to the Matryx Platform. You must approve this allowance.`
        })
      }
    }

    const tx = plannedTx(options.txFn)
    commit("ADD_PLANNED_TX", {
      tx,
      ...options
    })
    Vue.prototype.$web3.$emit("tx")

    return tx
  },

  clearPlannedTx({ commit }) {
    commit("CLEAR_PLANNED_TX")
  },

  dequeuePlannedTx({ state, commit }) {
    const firstTx = state.planned[0]
    commit("DEQUEUE_PLANNED_TX")
    return firstTx
  },

  addPendingTx({ commit }, tx) {
    commit("ADD_PENDING_TX", tx)
  },

  removeTx({ commit }, hash) {
    commit("REMOVE_PENDING_TX", hash)
  }
}

export default {
  state,
  mutations,
  actions
}
